import React from "react";

import IATATimelineItem from "./timeline-item";



class IATATimeline extends React.Component {

    render() {
        const { reports, fetchCallBack } = this.props;
        // debugger;
        console.log(reports, "reports in timeline");
        return (
            <div>
                {
                    reports.map((item, i) =>
                        <IATATimelineItem item={item} key={i} fetchCallBack={fetchCallBack}/>
                    )}
            </div>
        )
    }
}
export default IATATimeline;


// WEBPACK FOOTER //
// ./src/views/iata/timeline.js